<div class="btn-container">
    <div class="icono text-center">
        
        <mat-icon [inline]="true">error</mat-icon>
    </div>
    <br/>
    <mat-card-title class="dialog-title">{{data['titulo']}}</mat-card-title>
    <br/>
    <mat-card-content class="dialog-title">{{data['menssagejeError']}}</mat-card-content>
    <br/>
    <mat-card-actions class="text-center">
        <div *ngIf="aceptarCancelar">
            <div class="btn-container">
                <button mat-raised-button color="primary" (click)="aceptar()">{{textoBtnAceptar}}</button>
                <button mat-raised-button color="primary" (click)="cerrar()">{{textoBtnCerrar}}</button>
            </div>
        </div>
        <button mat-raised-button color="warn" *ngIf="!aceptarCancelar" class="col-md-8 m-auto"
                (click)="cerrar()">{{textoBtnCerrar}}</button>
    </mat-card-actions>
</div>

